import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import style from './ModalBase.module.scss';

const ModalBase = ({ children, className = '', name, title, onShow = () => {}, size = '' }) => {
  const modal = useSelector((state) => state.modal);
  const [clickedBg, setClickedBg] = useState(false);

  const onClickBg = () => {
    setClickedBg(true);

    setTimeout(() => {
      setClickedBg(false);
    }, 300);
  };

  useEffect(() => {
    if (modal.activeName === name) {
      onShow();
    }
  }, [modal.activeName, name, onShow]);

  return createPortal(
    <div className={`${style.modal} ${size ? style['modal-' + size] : ''} ${className}`}>
      <div className={style.modal_wrapper}>
        <div className={`${style.modal_content} ${clickedBg ? style['modal_content-scaleUp'] : ''}`}>
          {title ? <h4 className={style.modal_title}>{title}</h4> : ''}
          {children}
        </div>
        {size !== 'full' && <div className={style.modal_bg} onClick={onClickBg}></div>}
      </div>
    </div>,
    document.body
  );
};

export default ModalBase;
